export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/apps.1249990e.svg","height":166,"width":166,"blurWidth":0,"blurHeight":0};